import o from "./index92.js";
import r from "./index93.js";
import t from "./index94.js";
const l = {
  isBrowser: !0,
  classes: {
    URLSearchParams: o,
    FormData: r,
    Blob: t
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
};
export {
  l as default
};
